/* nicht-loeschen-galerie-thumbnails-mobile-pdp-slider.js  |  Galerie der Produktseite (Vorschau-Streifen am Handy, Variantenbilder, sizes)  |  Stand 2026-10-26
   DATEI NICHT LOESCHEN, NICHT UMBENENNEN: sie wird von den Custom-Liquid-Bloecken (Galerie-Lader) aus Inhalte -> Dateien geladen. Ohne sie bleibt die Galerie wie vorher.
   AKTUALISIEREN: in Inhalte -> Dateien die Datei anklicken und "Ersetzen" waehlen (nicht loeschen und neu hochladen). Ob die neue Fassung laeuft, zeigt window.GH_GAL_STAND in der Browser-Konsole.
   Fuenf Teile, jeder faengt seine Fehler selbst ab:
   A) Variantenbilder verstecken: nur bei der Variantenwahl ganz hinten einblenden (Hauptgalerie, Vorschau am Desktop, Vorschau am Handy)
   B) Vorschaubilder am Handy: eine Zeile, quadratisch, seitlich wischbar, aktives Bild wird mitgescrollt
   C) sizes fuer Vorschaubilder: der Browser laedt kleine statt riesiger Bilder
   D) eckige Bilder: grosse Bilder und Vorschaubilder NUR in der Produktgalerie ohne abgerundete Ecken (Einstellung ECKIG, standardmaessig aus, weil custom.css die Theme-Variable --media-border-radius auf 0 setzt)
   E) Mausrad: in der senkrechten Desktop-Vorschau scrollt das Mausrad durch die Vorschaubilder (Einstellung MAUSRAD); am Anfang und Ende der Leiste scrollt die Seite normal weiter, sobald die Leiste sich nicht mehr bewegen kann
   Die Datei enthaelt nur ASCII-Zeichen.
   Gesteuert ueber window.GH_GAL, das der Galerie-Lader vor dem Laden setzt:
   { ids: "Medien-IDs der Variantenbilder, Komma", keep: "Medien-ID der gewaehlten Variante", varianten: true/false, streifen: true/false, sichtbar: 4.5 } */
(function () {
  'use strict';
  var TAG = '[GH-GALERIE] ';
  var CFG = window.GH_GAL || {};
  /* EINSTELLUNGEN (hier aendern, dann die Datei in Dateien ersetzen; der Wert 'sichtbar' aus dem Lader wird ignoriert) */
  var SICHTBAR = 4.2;        /* wie viele Vorschaubilder am Handy auf einmal sichtbar sind (bei 440 px Breite: 4.5 = 85 px, 4.2 = 92 px, 3.5 = 111 px grosse Quadrate; die Nachkommastelle zeigt, dass es weiter geht) */
  var RAHMEN = '#2d6a30';    /* Farbe der Linie um das angezeigte Vorschaubild (dezenter z. B. #333333) */
  var RAHMEN_LAGE = 'aussen';  /* 'aussen': Linie liegt direkt AUSSEN am Quadrat (auf dem Seitenhintergrund, auf jedem Bild sichtbar); 'innen': Linie liegt auf dem Bildrand */
  var RAHMEN_BREITE = 1;     /* Dicke der Linie in Pixel, sie liegt genau auf dem Rand des Quadrats */
  var ECKIG = false;          /* true: die Bilder der Produktgalerie (grosse Bilder und Vorschaubilder) haben eckige Ecken; false: Rundung des Themes bleibt */
  var MAUSRAD = true;        /* true: das Mausrad scrollt in der Desktop-Vorschau durch die Vorschaubilder */
  var MAUSRAD_PAUSE = 120;   /* Pause in Millisekunden zwischen zwei Schritten (hoeher = langsamer, ruhiger bei Touchpads) */
  if (window.Shopify && window.Shopify.designMode) return;
  if (window.GH_GAL_AKTIV) return;
  window.GH_GAL_AKTIV = true;
  window.GH_GAL_STAND = '2026-10-26-a';

  function kinder(list) { return list ? Array.prototype.slice.call(list.children) : []; }
  function einzigartig(arr) { return arr.filter(function (x, i) { return arr.indexOf(x) === i; }); }
  function mobileListen() {
    var out = [];
    Array.prototype.forEach.call(document.querySelectorAll('.product-thumbnail-list-item'), function (li) {
      var u = li.parentElement;
      if (u && !u.closest('.splide--thumbnails') && out.indexOf(u) < 0) out.push(u);
    });
    return out;
  }

  /* ---------- A) Variantenbilder verstecken ---------- */
  function varianten() {
    var IDS = String(CFG.ids || '').split(',').filter(Boolean);
    var KEEP = String(CFG.keep || '');
    var root = document.querySelector('.splide--product');
    if (!root || !IDS.length) return;
    if (root.classList.contains('is-initialized') || (window.slideshows && window.slideshows[root.id])) {
      console.warn(TAG + 'Galerie schon gestartet, Skript laeuft zu spaet. Variantenbilder nicht veraendert.');
      return;
    }
    var mainList = root.querySelector('.splide__list');
    var thumbRoot = document.getElementById(root.id.replace('slideshow-', 'slideshow-thumbnails-')) || document.querySelector('.splide--thumbnails');
    var thumbList = thumbRoot && thumbRoot.querySelector('.splide__list');
    var mobil = mobileListen();
    if (!mainList) { console.warn(TAG + 'Folienliste nicht gefunden. Variantenbilder nicht veraendert.'); return; }

    var ersteId = mainList.children[0] ? mainList.children[0].getAttribute('data-media-id') : null;
    var listen = [thumbList].concat(mobil).filter(Boolean);
    var markerListen = listen.filter(function (l) { return kinder(l).some(function (k) { return k.hasAttribute('data-last-thumbnail'); }); });
    var vorlage = {}, versteckt = 0, gezeigt = null;

    kinder(mainList).forEach(function (li, i) {
      var id = li.getAttribute('data-media-id');
      if (i === 0 || id === ersteId || id === KEEP || IDS.indexOf(id) < 0) return;
      vorlage[id] = vorlage[id] || { thumbs: [] };
      vorlage[id].main = li.cloneNode(true);
      li.parentNode.removeChild(li);
      versteckt++;
    });
    listen.forEach(function (l, idx) {
      kinder(l).forEach(function (li) {
        var id = li.getAttribute('data-media-id');
        if (!vorlage[id]) return;
        vorlage[id].thumbs[idx] = li.cloneNode(true);
        li.parentNode.removeChild(li);
      });
    });
    window.GH_VAR_STATUS = { versteckt: versteckt, gezeigt: function () { return gezeigt; } };

    function lebt(s) { try { return !!s && !s.state.is(window.Splide.STATES.DESTROYED); } catch (e) { return false; } }
    function frisch(el) { var c = el.cloneNode(true); c.setAttribute('data-gh-variante', ''); return c; }
    function anhaengen(s, list, el) {
      if (!list || !el) return;
      if (s && lebt(s)) { try { s.add(el); return; } catch (e) { console.warn(TAG + 'add() fehlgeschlagen, setze im HTML ein', e); } }
      list.appendChild(el);
    }
    function entfernen(s, list) {
      if (!list || !list.querySelector('[data-gh-variante]')) return;
      if (s && lebt(s)) { try { s.remove('[data-gh-variante]'); return; } catch (e) { console.warn(TAG + 'remove() fehlgeschlagen, entferne im HTML', e); } }
      Array.prototype.slice.call(list.querySelectorAll('[data-gh-variante]')).forEach(function (n) { n.parentNode.removeChild(n); });
    }
    function letzteMarkieren() {
      markerListen.forEach(function (l) {
        var ks = kinder(l);
        ks.forEach(function (k) { k.removeAttribute('data-last-thumbnail'); });
        if (ks.length) ks[ks.length - 1].setAttribute('data-last-thumbnail', '');
      });
    }

    document.addEventListener('shapes:product:variantchange', function (e) {
      try {
        var v = e.detail && e.detail.variant, id = v && v.featured_media && String(v.featured_media.id);
        if (!id) return;
        var reg = window.slideshows || {};
        var sm = reg[root.id], st = reg[root.id.replace('slideshow-', 'slideshow-thumbnails-')];
        if (gezeigt && gezeigt !== id) {
          entfernen(sm, mainList);
          listen.forEach(function (l) { entfernen(l === thumbList ? st : null, l); });
          gezeigt = null;
        }
        if (vorlage[id] && gezeigt !== id) {
          anhaengen(sm, mainList, frisch(vorlage[id].main));
          listen.forEach(function (l, idx) { if (vorlage[id].thumbs[idx]) anhaengen(l === thumbList ? st : null, l, frisch(vorlage[id].thumbs[idx])); });
          gezeigt = id;
        }
        letzteMarkieren();
      } catch (err) { console.warn(TAG + 'Fehler beim Einsetzen des Variantenbilds', err); }
    }, true);
    if (versteckt) console.info(TAG + versteckt + ' Variantenbilder aus der Galerie genommen, sie erscheinen bei der Variantenwahl ganz hinten.');
  }

  /* ---------- B) Vorschau-Streifen am Handy ---------- */
  function streifen() {
    var listen = mobileListen();
    if (!listen.length) return;
    var N = SICHTBAR > 1 ? SICHTBAR : 4.2, GAP = 8;
    var versatz = RAHMEN_LAGE === 'innen' ? '0' : '-' + RAHMEN_BREITE + 'px';
    var css = '@media (max-width: 989px) {' +
      'ul.gh-thumbstrip{display:flex!important;grid-template-columns:none!important;flex-wrap:nowrap!important;gap:' + GAP + 'px!important;overflow-x:auto!important;overflow-y:hidden!important;position:relative!important;' +
      '-webkit-overflow-scrolling:touch;scroll-snap-type:x proximity;overscroll-behavior-x:contain;scrollbar-width:none;scroll-padding-left:4px;padding:4px 0 6px 4px!important}' +
      'ul.gh-thumbstrip::-webkit-scrollbar{display:none}' +
      'ul.gh-thumbstrip::after{content:"";flex:0 0 2px}' +
      'ul.gh-thumbstrip>li{position:relative!important;flex:0 0 calc((100% - ' + (Math.ceil(N) - 1) + ' * ' + GAP + 'px) / ' + N + ')!important;width:auto!important;max-width:none!important;height:auto!important;aspect-ratio:1/1!important;padding:0!important;margin:0!important;border-radius:0!important;scroll-snap-align:start;-webkit-tap-highlight-color:transparent}' +
      'ul.gh-thumbstrip>li>a{display:block!important;width:100%!important;height:100%!important;border-radius:0!important}' +
      'ul.gh-thumbstrip>li img{display:block!important;width:100%!important;height:100%!important;aspect-ratio:1/1!important;object-fit:cover!important;margin:0!important;border-radius:0!important}' +
      'ul.gh-thumbstrip>li::after{content:"";position:absolute;top:' + versatz + ';right:' + versatz + ';bottom:' + versatz + ';left:' + versatz + ';box-sizing:border-box;border:' + RAHMEN_BREITE + 'px solid ' + RAHMEN + ';opacity:0;pointer-events:none;transition:opacity .15s}' +
      'ul.gh-thumbstrip>li.gh-thumb-aktiv::after{opacity:1}' +
      '.gh-thumbstrip-rand{padding-right:0!important}}';
    var st = document.createElement('style'); st.setAttribute('data-gh-galerie', 'streifen'); st.appendChild(document.createTextNode(css)); document.head.appendChild(st);

    var root = document.querySelector('.splide--product');
    var mainList = root && root.querySelector('.splide__list');
    function aktuelleId() { var a = mainList && mainList.querySelector('.splide__slide.is-active'); return a ? a.getAttribute('data-media-id') : null; }
    function mitscrollen(u) {
      if (window.innerWidth >= 990 || u.scrollWidth <= u.clientWidth + 1) return;
      var a = u.querySelector('.gh-thumb-aktiv');
      if (!a) return;
      var links = a.offsetLeft, rechts = links + a.offsetWidth;
      if (links >= u.scrollLeft && rechts <= u.scrollLeft + u.clientWidth) return;
      var ziel = Math.max(0, links - (u.clientWidth - a.offsetWidth) / 2);
      if (u.scrollTo) u.scrollTo({ left: ziel, behavior: 'smooth' }); else u.scrollLeft = ziel;
    }
    function markieren() {
      var id = aktuelleId();
      if (!id) return false;
      listen.forEach(function (u) {
        kinder(u).forEach(function (li) { li.classList.toggle('gh-thumb-aktiv', li.getAttribute('data-media-id') === id); });
        mitscrollen(u);
      });
      return true;
    }
    listen.forEach(function (u) {
      u.classList.add('gh-thumbstrip');
      if (u.parentElement) u.parentElement.classList.add('gh-thumbstrip-rand');
      if (window.MutationObserver) new MutationObserver(markieren).observe(u, { childList: true });
    });
    if (mainList && window.MutationObserver) new MutationObserver(markieren).observe(mainList, { subtree: true, attributes: true, attributeFilter: ['class'], childList: true });
    var versuche = 0, iv = setInterval(function () { if (markieren() || ++versuche > 20) clearInterval(iv); }, 200);
    window.addEventListener('load', markieren);
  }

  /* ---------- C) sizes fuer Vorschaubilder ---------- */
  function groessen() {
    var N = SICHTBAR > 1 ? SICHTBAR : 4.2;
    var sz = '(min-width: 990px) 120px, ' + Math.ceil(100 / N) + 'vw';
    var imgs = Array.prototype.slice.call(document.querySelectorAll('.splide--thumbnails img'));
    mobileListen().forEach(function (u) { imgs = imgs.concat(Array.prototype.slice.call(u.querySelectorAll('img'))); });
    imgs.forEach(function (img) { if (!img.getAttribute('sizes')) img.setAttribute('sizes', sz); });
  }

  /* ---------- D) eckige Bilder in der Produktgalerie ---------- */
  function eckig() {
    var st = document.createElement('style'); st.setAttribute('data-gh-galerie', 'eckig');
    st.appendChild(document.createTextNode('.splide--product .media-style,.splide--thumbnails .media-style{border-radius:0!important}'));
    document.head.appendChild(st);
  }

  /* ---------- E) Mausrad in der Desktop-Vorschau ---------- */
  function mausrad() {
    var root = document.querySelector('.splide--thumbnails') || document.querySelector('[id^="slideshow-thumbnails"]');
    if (!root || !root.id) return;
    if (window.GH_MAUSRAD_AKTIV) return;      /* nur einmal, auch wenn der Konsolen-Test schon laeuft */
    window.GH_MAUSRAD_AKTIV = true;
    var zuletzt = 0;
    root.addEventListener('wheel', function (e) {
      try {
        if (window.innerWidth < 990 || e.ctrlKey || e.defaultPrevented) return;
        var dy = e.deltaY;
        if (!dy || Math.abs(e.deltaX) > Math.abs(dy)) return;
        var s = window.slideshows && window.slideshows[root.id];
        var M = s && s.Components && s.Components.Move;
        if (!M || (window.Splide && window.Splide.STATES && s.state.is(window.Splide.STATES.DESTROYED))) return;
        var pos = M.getPosition(), ende = M.getLimit(true), anfang = M.getLimit(false), richtung = ende >= anfang ? 1 : -1;
        if (Math.abs(ende - anfang) < 2) return;                       /* nichts zu scrollen: Seite scrollt normal */
        var vor = dy > 0;
        var rest = vor ? (ende - pos) * richtung : (pos - anfang) * richtung;
        if (rest <= 1) return;                                          /* Anfang oder Ende erreicht: Seite scrollt normal weiter */
        e.preventDefault();
        var jetzt = Date.now();
        if (jetzt - zuletzt < MAUSRAD_PAUSE) return;
        zuletzt = jetzt;
        var schritt = Math.abs(M.toPosition(1) - M.toPosition(0)) || Math.abs(ende - anfang) / Math.max(1, s.length - 1);
        var neuePos = pos + (vor ? 1 : -1) * richtung * schritt;
        neuePos = richtung > 0 ? Math.max(anfang, Math.min(ende, neuePos)) : Math.max(ende, Math.min(anfang, neuePos));
        var ziel = M.toIndex(neuePos);
        if (Math.abs(M.toPosition(ziel, true) - pos) < 1) ziel += vor ? 1 : -1;      /* nie auf der Stelle treten */
        s.go(Math.max(0, Math.min(s.length - 1, ziel)));
      } catch (err) { console.warn(TAG + 'Mausrad-Fehler', err); }
    }, { passive: false });
  }

  function sicher(name, fn) { try { fn(); } catch (e) { console.warn(TAG + 'Teil ' + name + ' fehlgeschlagen', e); } }
  if (ECKIG) sicher('D (eckige Bilder)', eckig);
  if (MAUSRAD) sicher('E (Mausrad)', mausrad);
  if (CFG.varianten !== false) sicher('A (Variantenbilder)', varianten);
  if (CFG.streifen !== false) sicher('B (Vorschau-Streifen)', streifen);
  sicher('C (sizes)', groessen);
})();
